import React, { Component } from 'react';
import { DataTypes } from '../../constants/CentricConstants';
import { Container } from 'flux/utils';
import Form from '../Common/Form.react';
import FileUpload from '../Common/FormsyFileUpload';
import TextField from '../Common/TextField';
import { Card, CardText } from 'material-ui/Card';
import SelectField from '../Common/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Slider from 'material-ui/Slider';

import CertificateActions from '../../actions/CertificateActionCreator';
import CertificateStore from '../../stores/CertificateStore';
import DataStore from '../../stores/DataStore';
import { withId } from '../Common/Decorators';

const getDefaults = () => ({
    name: '',
    authority: null,
    paperSizeId: null,
    paperSizeOptions: [],
    watermarkAlpha: 1
});

class CertificateForm extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
        if (!!this.props.id) {
            CertificateActions.getById(this.props.id);
        }
        CertificateActions.getPaperSizes();
    }


    render() {
        return (
            <Form
                title={(!!this.props.id ? this.state.name : 'New Certificate')}
                onSave={this.onSave}
                showProgress={!!this.state.isFetching}
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            floatingLabelText="Name"
                            value={this.state.name}
                            validations="minLength:6,maxLength:80"
                            validationError="Minimum of 6 alpha numeric characters"
                            required
                        />
                        <TextField
                            name="authority"
                            floatingLabelText="Issuing authority"
                            validations="minLength:3,maxLength:80"
                            validationError="Minimum of 3 alpha numeric characters"
                            value={this.state.authority}
                        />
                        <SelectField
                            name="paperSizeId"
                            value={this.state.paperSizeId}
                            floatingLabelText="Paper size"
                            autoWidth={true}
                            required
                        >
                            {this.state.paperSizeOptions.map(({id, name}) => (
                                <MenuItem key={id} value={id} primaryText={name} label={name}/>
                            ))}
                        </SelectField>
                        <CardText>
                            Choose an image file (.png) for your certificate.
                        </CardText>
                        <FileUpload
                            name="certificate"
                            required={!this.props.id}
                            allowedMimeTypes={['image/gif', 'image/jpeg', 'image/png']}
                            errorMessage="Invalid file type"
                        />
                        <br />
                        <label>Image alpha layer</label>
                        <Slider
                            value={this.state.watermarkAlpha}
                            onChange={(event, value) => this.setState({watermarkAlpha: value})}
                        />
                    </CardText>
                </Card>
            </Form>
        );
    }

    onSave(formData) {
        const { certificate, ...data } = formData;
        data.watermarkAlpha = this.state.watermarkAlpha;
        if (!!this.props.id) {
            CertificateActions.update(this.props.id, data, certificate);
        } else {
            CertificateActions.add(data, certificate);
        }
    }

}

CertificateForm.getStores = () => ([CertificateStore, DataStore]);
CertificateForm.calculateState = (prevState, {id}) => ({
    isFetching: id ? CertificateStore.isFetching() : false,
    ...(id ? CertificateStore.getById(id) : getDefaults()),
    paperSizeOptions: DataStore.get(DataTypes.PAPER_SIZE_LIST) || []
});

export default withId(Container.create(CertificateForm, {withProps: true}));
